export default "dist/images/components-design-separator-control-rounded-3.78cb6da.png";